import React, { useContext, useEffect, useRef, useState } from "react";
import { IRecipientDetails } from "../../../../models/buy-giftcard/choose-card/ChooseRecipientsStep.model";
import { GiftCardSendTypeEnum } from "../../../../models/enums/GiftCardSendTypeEnum";
import { IBuyGiftCardStepProps } from "../../../../models/interfaces/BuyGiftCardStep.interface";
import { AppSettingContext } from "../../../Application";
import LoadingComponent from "../../../shared/LoadingComponent";

export interface IReviewAndPayReviewStepModel {
    recipients: Array<IRecipientDetails>;
    sendBy: GiftCardSendTypeEnum;
    totalAmount: number;
}

interface IReviewAndPayReviewStepProps extends IBuyGiftCardStepProps {
    stepModel: IReviewAndPayReviewStepModel;
}

const ReviewAndPayReviewStep = (props: IReviewAndPayReviewStepProps) => {
    const { labels } = useContext(AppSettingContext);
    const checkboxRef = useRef(null);

    //#region STATE PROPERTIES

    const [isLoading, setIsLoading] = useState(true);
    const [expandRecipients, setExpandRecipients] = useState(false);

    //#endregion

    //#region USE EFFECT HOOKS

    useEffect(() => {
        setIsLoading(props.isSaving);
    }, [props.isSaving]);

    //#endregion

    return (
        <div className="box">
            <input
                type="checkbox"
                name="reviewpay"
                id="reviewpay"
                ref={checkboxRef}
                defaultChecked={true}
            />
            <div className="action-card">
                <h4 className="box-heading">
                    <i className="box-icon">
                        <img src="/static/options-card-page/options-card-icon-07.png" alt="icon 07" />
                    </i>
                    {labels.get("GiftCard.App.V2.ReviewAndPayReview.Title")}
                    <i
                        className="box-arrow"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            checkboxRef.current.checked = !checkboxRef.current.checked;
                        }}
                    ></i>
                </h4>
                <div className="show">
                    {isLoading ? (
                        <LoadingComponent />
                    ) : (
                        <div className="slide-content">
                            <h5>{labels.get("GiftCard.App.V2.ReviewAndPayReview.Subtitle")}</h5>
                            <table className="sending-to">
                                <thead>
                                    <tr>
                                        <th>{props.stepModel.recipients.length} Recipient{props.stepModel.recipients.length > 1 ? "s" : ""}</th>
                                        <th>
                                            <i
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => setExpandRecipients(!expandRecipients)}
                                            >
                                                {expandRecipients ? (
                                                    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1 7.6L7 1.6L13 7.6" stroke="#111827" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                ) : (
                                                    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1 1.40002L7 7.40002L13 1.40002" stroke="#111827" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                )}
                                            </i>
                                        </th>
                                    </tr>
                                </thead>
                                {expandRecipients && (
                                    <tbody>
                                        {props.stepModel.recipients.map((recipient, index) => (
                                            <tr key={`recipient_${index}`} style={{ backgroundColor: 'var(--cl-r-primary-100)' }}>
                                                <td style={{ fontWeight: 'normal', fontSize: '14px' }}>
                                                    <p>{recipient.fullName}</p>

                                                    {props.stepModel.sendBy == GiftCardSendTypeEnum.BY_EMAIL && (
                                                        <p>{recipient.email}</p>
                                                    )}
                                                    {props.stepModel.sendBy == GiftCardSendTypeEnum.BY_SMS && (
                                                        <p>{recipient.phone}</p>
                                                    )}
                                                </td>
                                                <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                                                    <p>&euro;{(props.stepModel.totalAmount / props.stepModel.recipients.length).toFixed(2)}</p>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                )}
                                <tfoot>
                                    <tr>
                                        <td>{labels.get("GiftCard.App.V2.ReviewAndPayReview.Label.Total")}</td>
                                        <td>&euro;{props.stepModel.totalAmount.toFixed(2)}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReviewAndPayReviewStep;